<template>
  <div class="chat-app__wrapper chat-app__wrapper_alt">
    <perfect-scrollbar id="container">
      <message
          v-for="(question, index) in questions"
          v-bind:message="question"
          v-bind:index="index"
          v-bind:key="question.id"
          :on-delete="onDelete"
          :on-unmark-question="onUnmarkQuestion"
          :on-mark-attention="onMarkAttention"
          :on-unmark-attention="onUnmarkAttention"
          :on-like="onLike"
          :on-dislike="onDislike"
      ></message>
    </perfect-scrollbar>
  </div>
</template>

<script>
  import Message from "./Message";
  import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

  export default {
    components: {Message, PerfectScrollbar},
    props: ['onDelete', 'onUnmarkQuestion', 'onMarkAttention', 'onUnmarkAttention', 'onLike', 'onDislike'],
    name: "ChatQuestions",
    computed: {
      questions () {
        return this.$store.getters.getQuestions
      }
    },
    updated(){
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    }
  }
</script>
